import React from 'react'

export const Review = ({ className }: { className?: string }) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="13.25" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 14C10 15.6569 8.65685 17 7 17C5.34315 17 4 15.6569 4 14C4 12.3431 5.34315 11 7 11C8.65685 11 10 12.3431 10 14ZM17 14C17 15.6569 15.6569 17 14 17C12.3431 17 11 15.6569 11 14C11 12.3431 12.3431 11 14 11C15.6569 11 17 12.3431 17 14ZM22.5 14C22.5 14.8284 21.8284 15.5 21 15.5C20.1716 15.5 19.5 14.8284 19.5 14C19.5 13.1716 20.1716 12.5 21 12.5C21.8284 12.5 22.5 13.1716 22.5 14ZM24 14C24 15.6569 22.6569 17 21 17C19.3431 17 18 15.6569 18 14C18 12.3431 19.3431 11 21 11C22.6569 11 24 12.3431 24 14Z"
      fill="black"
    />
    <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="13.25" stroke="black" strokeWidth="1.5" />
  </svg>
)
